<template>
	<div class="i-currency" v-if="value">
		<div v-for="(curr,i) in Object.keys(value)" v-if="value[curr]!=0" :style="{color:colors[i]}">
			{{curr}}: {{value[curr] | numbering}}
		</div>
	</div>
</template>

<script>
export default {
	props:["value"],
  name: 'i-currency',

  data () {
    return {
    	colors:[/*"#7ED321","#FF4D4D","#4A90E2","#9013FE","#FFF46A"*/]
    }
  }
}
</script>

<style lang="css" scoped>
.i-currency{
	display: inline-block;
}
table{
	border-collapse: collapse;
}
</style>